export const GET_THIRD_PARTY_DATA_REQUEST = 'GET_THIRD_PARTY_DATA_REQUEST';
export const GET_THIRD_PARTY_DATA_ERROR = 'GET_THIRD_PARTY_DATA_ERROR';
export const GET_THIRD_PARTY_DATA_SUCCESS = 'GET_THIRD_PARTY_DATA_SUCCESS';

export const GET_ALL_DOMAINS_FOR_PROCESSING_REQUEST =
  'GET_ALL_DOMAINS_FOR_PROCESSING_REQUEST';
export const GET_ALL_DOMAINS_FOR_PROCESSING_SUCCESS =
  'GET_ALL_DOMAINS_FOR_PROCESSING_SUCCESS';
export const GET_ALL_DOMAINS_FOR_PROCESSING_FAILED =
  'GET_ALL_DOMAINS_FOR_PROCESSING_FAILED';
export const GET_ALL_DOMAINS_FOR_PROCESSING_CLEAR =
  'GET_ALL_DOMAINS_FOR_PROCESSING_CLEAR';

export const CHECK_RESERVED_DOMAINS_IDS_REQUEST =
  'CHECK_RESERVED_DOMAINS_IDS_REQUEST';
export const CHECK_RESERVED_DOMAINS_IDS_SUCCESS =
  'CHECK_RESERVED_DOMAINS_IDS_SUCCESS';
export const CHECK_RESERVED_DOMAINS_IDS_FAILED =
  'CHECK_RESERVED_DOMAINS_IDS_FAILED';
export const CHECK_RESERVED_DOMAINS_IDS_CLEAR =
  'CHECK_RESERVED_DOMAINS_IDS_CLEAR';

export const GET_DOMAIN_IMAGE_COUNT_DATA_REQUEST =
  'GET_DOMAIN_IMAGE_COUNT_DATA_REQUEST';
export const GET_DOMAIN_IMAGE_COUNT_DATA_SUCCESS =
  'GET_DOMAIN_IMAGE_COUNT_DATA_SUCCESS';
export const GET_DOMAIN_IMAGE_COUNT_DATA_FAILED =
  'GET_DOMAIN_IMAGE_COUNT_DATA_FAILED';
export const GET_DOMAIN_IMAGE_COUNT_DATA_CLEAR =
  'GET_DOMAIN_IMAGE_COUNT_DATA_CLEAR';

export const SAVE_DOMAIN_DATA_REQUEST = 'SAVE_DOMAIN_DATA_REQUEST';
export const SAVE_DOMAIN_DATA_SUCCESS = 'SAVE_DOMAIN_DATA_SUCCESS';
export const SAVE_DOMAIN_DATA_FAILED = 'SAVE_DOMAIN_DATA_FAILED';
export const SAVE_DOMAIN_DATA_CLEAR = 'SAVE_DOMAIN_DATA_CLEAR';

export const CHANGE_DOMAINS_WORK_DATA = 'CHANGE_DOMAINS_WORK_DATA';
